var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H2C0.9 2 0 2.9 0 4V16C0 17.1 0.9 18 2 18H18C19.1 18 20 17.1 20 16V4C20 2.9 19.1 2 18 2ZM17.6 6.25L11.06 10.34C10.41 10.75 9.59 10.75 8.94 10.34L2.4 6.25C2.29973 6.19371 2.21192 6.11766 2.14189 6.02645C2.07186 5.93525 2.02106 5.83078 1.99258 5.71937C1.96409 5.60796 1.9585 5.49194 1.97616 5.37831C1.99381 5.26468 2.03434 5.15581 2.09528 5.0583C2.15623 4.96079 2.23632 4.87666 2.33073 4.811C2.42513 4.74533 2.53187 4.69951 2.6445 4.6763C2.75712 4.65309 2.87328 4.65297 2.98595 4.67595C3.09863 4.69893 3.20546 4.74453 3.3 4.81L10 9L16.7 4.81C16.7945 4.74453 16.9014 4.69893 17.014 4.67595C17.1267 4.65297 17.2429 4.65309 17.3555 4.6763C17.4681 4.69951 17.5749 4.74533 17.6693 4.811C17.7637 4.87666 17.8438 4.96079 17.9047 5.0583C17.9657 5.15581 18.0062 5.26468 18.0238 5.37831C18.0415 5.49194 18.0359 5.60796 18.0074 5.71937C17.9789 5.83078 17.9281 5.93525 17.8581 6.02645C17.7881 6.11766 17.7003 6.19371 17.6 6.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.b835f59ae6a1c78cea96a32ff2442116.svg";
export { ForwardRef as ReactComponent };